import { RafScoreExecutionDay, RafScoreExecutionRun } from '@/models'
import axios, { AxiosResponse } from 'axios'

const API_URL = 'RafScoreEvents'

export const getRafScoreDailyHistory = async (
  pageNumber = 1,
  pageSize = 20
): Promise<AxiosResponse<RafScoreExecutionDay[]>> => {
  return axios.get<RafScoreExecutionDay[]>(`${API_URL}/daily`, {
    params: {
      pageNumber,
      pageSize
    }
  })
}

export const getRafScoreRunsByDate = async (
  date: string
): Promise<AxiosResponse<RafScoreExecutionRun[]>> => {
  return axios.get<RafScoreExecutionRun[]>(`${API_URL}/runs`, {
    params: { date }
  })
}
